import script from "./altTable.vue?vue&type=script&setup=true&lang=js"
export * from "./altTable.vue?vue&type=script&setup=true&lang=js"

import "./altTable.vue?vue&type=style&index=0&id=e376981c&lang=scss"

const __exports__ = script;

export default __exports__